/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb4_Point_1_TextInputs */

const en_visa_eb4_point_1_text = /** @type {(inputs: Visa_Eb4_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We evaluate the underlying role, organization, and immigration history to determine whether any special immigrant classification may apply.`)
};

const pt_visa_eb4_point_1_text = /** @type {(inputs: Visa_Eb4_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliamos a função subjacente, organização e histórico de imigração para determinar se alguma classificação de imigrante especial pode se aplicar.`)
};

const es_visa_eb4_point_1_text = /** @type {(inputs: Visa_Eb4_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluamos la función subyacente, la organización y el historial de inmigración para determinar si alguna clasificación de inmigrante especial puede aplicar.`)
};

/**
* | output |
* | --- |
* | "We evaluate the underlying role, organization, and immigration history to determine whether any special immigrant classification may apply." |
*
* @param {Visa_Eb4_Point_1_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb4_point_1_text = /** @type {((inputs?: Visa_Eb4_Point_1_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb4_Point_1_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb4_point_1_text(inputs)
	if (locale === "es") return es_visa_eb4_point_1_text(inputs)
	return en_visa_eb4_point_1_text(inputs)
});